import { Khonsole } from 'app/khonsole';
import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  Renderer2
} from '@angular/core';
import * as d3 from 'd3';
 
import { WidgetComponent } from "./widget.component";
import * as _ from 'lodash';
import { GraphConfig } from '../../../model/graph-config.model';
import { DataDecorator, DataDecoratorTypeEnum } from '../../../model/data-map.model';
import { DataService } from 'app/service/data.service';
import { ComputeWorkerUtil } from 'app/service/compute.worker.util';
import { WorkspaceComponent } from '../workspace.component';
import { SelectionModifiers } from 'app/component/visualization/visualization.abstract.scatter.component';
import { CollectionTypeEnum, EntityTypeEnum } from 'app/model/enum.model';
import { ChartScene } from 'app/component/workspace/chart/chart.scene';
import { LoadedTable, OncoData } from 'app/oncoData';
import { TooltipContextObject } from './tooltipContextObject';
import { Cohort } from '../../../model/cohort.model';

@Component({
  selector: 'html-widget',
  templateUrl: './widget.html',
  styleUrls: ['./common-side-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})

export class HtmlWidgetComponent extends WidgetComponent {
  constructor(
    renderer: Renderer2
  ) 
  { 
    super(renderer);
    this.model.name = "Html";
    this.model.preferredHeight = null; // Autogrow, unlike forced height like "130px";
    this.usesSvg = false;
  }

  clearContents(){
    Khonsole.warn("html-widget avoids this.clearSvg");
  }

  ngAfterViewInit(): void {}

  ngOnDestroy() {}

}